import {racesTermsAndConditions, dailyTableNames, racesNames, racesLinks} from "./config";

export const getNameByCode = (code) => {
    const name = Object.keys(racesNames).filter(name => code.includes(racesNames[name].raceCode))
    return name.length > 0
        ? { title: racesNames[name[0]].title, faqInfo: racesNames[name[0]].faqInfo }
        : { title: 'PLACEHOLDER', faqInfo: 'THIS IS A PLACEHOLDER TEXT FOR THE BODY, IF YOU SEE THIS PLEASE REPORT' }
}

export const getDailyTableName = (code) => {
    const name = Object.keys(dailyTableNames).filter(name => dailyTableNames[name].includes(code))
    return name[0] || 'Premii instant'
}

export const isPrincessAgent = () => {
    const mobileAppUserAgent = "Mozilla/5.0 (Linux; Android 8.0.0; mobile-app-android) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/84.0.4147.111 Mobile Safari/537.36"
    return window.navigator && ((window.navigator.userAgent === mobileAppUserAgent) ||
        window.navigator.userAgent.indexOf('mobile-app-android') !==-1)
}

export const getPrizeNameByType = (type) => {
    const names = {
        campaign : 'Runde Gratuite',
        promo: 'RON Bonus',
        cash: 'RON CASH',
        iphone: 'Iphone'
    }
    if(names[type] === undefined) {
        console.log(type)
        return 'Lei'
    }
    return names[type]
}

export const tableForSpins = (list) => {
    const rewards = new Set(list.map(el => el.prizeType))
    return rewards.size === 1 && [...rewards][0] === 'campaign'
}

export const getTermsAndConditions = (code) => {
    return racesTermsAndConditions[code]
}

export const getRaceLink = (code) => {
    return racesLinks[code] || 'https://www.princesscasino.ro/?modal=login'
}